import create from './create'
import update from './update'

const validators = {
  create,
  update
}

export default validators
